<template>
  <div class="board__badges px-3 pb-4">
    <v-chip :color="color(badgeColor)" small dark>
      {{ $t(label) }}
    </v-chip>
  </div>
</template>

<script>
import { appointmentStatusColors } from '@/util/colors'

export default {
  name: 'BoardCardBadges',

  props: {
    label: {
      type: String,
    },
    badgeColor: {
      type: String,
    }
  },

  data() {
    return {
      color: appointmentStatusColors,
    }
  },
}
</script>
